import { render, staticRenderFns } from "./EquipmentWC.vue?vue&type=template&id=3bc3bc4d&scoped=true"
import script from "./EquipmentWC.vue?vue&type=script&lang=ts"
export * from "./EquipmentWC.vue?vue&type=script&lang=ts"
import style0 from "./EquipmentWC.vue?vue&type=style&index=0&id=3bc3bc4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc3bc4d",
  null
  
)

export default component.exports